import { Button, Form } from "react-bootstrap";

export default function ContactRow({ contact, selected, onToggle,onDelete }) {
  return (
    <tr className={selected ? "contacts-row selected" : "contacts-row"}>
      <td className="contacts-table-check">
        <Form.Check checked={selected} onChange={() => onToggle(contact.id)} />
      </td>
      <td>
        <div className="contacts-name">{contact.name}</div>
        <div className="contacts-tag">{contact.tag || "No tag"}</div>
      </td>
      <td>
        <div className="contacts-phone">{contact.phone}</div>
        <div className="contacts-subtext">{contact.place || "No place"}</div>
      </td>
      <td className="contacts-table-actions">
        <Button
          variant="outline-danger"
          size="sm"
          className="contacts-delete-btn"
          onClick={() => onDelete(contact.id)}
        >
          Delete
        </Button>
      </td>
    </tr>
  );
}
